import { Component, Input, OnInit } from '@angular/core';
import { Activity } from '../models';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit {
  @Input() backgroundColor = 'white';
  @Input() highlightColor = 'black';
  @Input() activity: Activity;

  currentDate;
  currentDayOfTheWeek;
  activitiesCalendar = {};
  loadingCompleted = false;
  activities;

  constructor(private dataService: DataService) {}

  ngOnInit() {
    if (this.activity) {
      this.currentDate = new Date(this.activity.start_date).getDate();
      this.currentDayOfTheWeek = new Date(this.activity.start_date).getDay();
    } else {
      this.currentDate = new Date().getDate();
      this.currentDayOfTheWeek = new Date().getDay();
    }

    this.getData();
  }

  addDay(days) {
    const b = this.activity
      ? new Date(this.activity.start_date).getTime() +
        days * 24 * 60 * 60 * 1000
      : new Date().getTime() + days * 24 * 60 * 60 * 1000;
    return new Date(b).getDate();
  }

  getData() {
    this.dataService
      .getPastActivities(this.activity ? this.activity.start_date : new Date())
      .subscribe((res) => {
        res.forEach((activity) => {
          const date = new Date(activity.start_date);
          const now = this.activity
            ? new Date(this.activity.start_date)
            : new Date();
          now.setUTCHours(0, 0, 0, 0);
          const diff = Math.floor(
            (date.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
          );
          if (!this.activitiesCalendar[diff]) {
            this.activitiesCalendar[diff] = [];
          }
          this.activitiesCalendar[diff].push(activity);
        });
        this.activities = res;
        this.loadingCompleted = true;
      });
  }

  getClass(day, olderDates?) {
    return olderDates ? null : this.activitiesCalendar[day];
  }
}
